import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { StateService } from '../../../services';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-state-view-modal',
  templateUrl: './state-view-modal.component.html',
  styleUrls: ['./state-view-modal.component.css']
})
export class StateViewModalComponent{

  stateDetail: any;
  idFromParent: number;

  constructor(
    private spinner: NgxSpinnerService,
    private stateService:StateService,
    public ref: DynamicDialogRef, 
    public config: DynamicDialogConfig
  ) 
  { 
    this.idFromParent = config.data.id;
  }

  ngOnInit(): void {
    this.getStateDetails();
  }

  getStateDetails()
  {
    this.stateService.getStateDetail(this.idFromParent).subscribe((data: any) => {
      this.stateDetail = data;
      console.log('this.stateDetail');
      console.log(this.stateDetail);
     });
  }

}
